import React from 'react'
import N from '../C_Topics/assets/N.jpg'
const Sum_of_n = () => {
    return (
        <div className='container'>
            <h1>Flowchart and Pseudocode to find the sum of N numbers</h1>
            <p><strong>What is a Natural Number?</strong></p>
            <p>It is series of the number starting from 1 to infinity. It does not include 0 or negative numbers.</p>
            <p><strong>What should be the approach for this program?</strong></p>
            <p>As we have to count until the number given it definitely means we have to use loop until the number. So what can we do is we use a variable to store the previous number of the loop and keep adding the new number.
<br /> <br />
So we will use for The loop will run n times ,so we declare variable sum and store the value of sum and iteration of the loop. print that number.</p> <br />
<p><strong>Flowchart for finding the sum of Natural Number</strong></p>
<img src={N} alt="" />
<p><strong>Pseudocode for finding the sum of Natural Number</strong></p>
<p>
Declare a variable n, i and sum as integer; <br />
Read number n ; <br />
for i upto n increment i by 1 and i=1 <br />
&#123; <br />
sum=sum+i; <br />
&#125; <br />
Print sum; <br />
</p>

        </div>
    )
}

export default Sum_of_n
